import React from 'react';

// Create a context with no initial values.
export const EnvironmentContext = React.createContext();

export default EnvironmentContext;
